import { gql } from '@apollo/client';
import React from 'react';
import { ProductDetailPageMetaFragment } from '../../generated/types/ProductDetailPageMetaFragment';
import { PageMeta } from '../../components/PageMeta';
import { useUrlParams } from '../../hooks/useUrlParams';

export const PRODUCT_DETAIL_PAGE_META_FRAGMENT = gql`
  fragment ProductDetailPageMetaFragment on Variant {
    name
    designerName: designer_name
    masterVariantId: master_variant_id
    id
    masterVariant: master_variants_data {
      primaryImage: primary_image_urls {
        medium
      }
    }
  }
`;

interface Props {
  variant: ProductDetailPageMetaFragment;
}

export const ProductDetailPageMeta: React.FC<Props> = ({ variant }) => {
  const { getHrefFor, pathnameParams } = useUrlParams();
  const masterVariantId =
    (variant.masterVariantId && variant.masterVariantId.toString()) || variant.id.toString();
  const canonicalPath = getHrefFor({ ...pathnameParams, variantId: masterVariantId });
  const description = `Shop the ${variant.name} by ${variant.designerName} and more new designer fashion on Moda Operandi.`;

  return (
    <PageMeta
      title={`${variant.name} by ${variant.designerName}`}
      description={description}
      image={variant.masterVariant.primaryImage.medium ?? undefined}
      canonicalPath={canonicalPath}
    />
  );
};
